import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

export interface ToggleTabsOption {
  label: string;
  value: any;
  checked?: boolean;
  disabled?: boolean;
  routerLink?: string;
}

@Component({
  selector: 'vfs-button-toggle-tabs',
  templateUrl: './button-toggle-tabs.component.html',
  styleUrls: ['./button-toggle-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonToggleTabsComponent {
  @Input() options: ToggleTabsOption[];
  @Output() changeValue = new EventEmitter<any>();

  change(event) {
    this.changeValue.emit(event.value);
  }
}
